import { render, staticRenderFns } from "./VerDetalleSimSolicitudes.vue?vue&type=template&id=2fd864c5&scoped=true&"
import script from "./VerDetalleSimSolicitudes.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleSimSolicitudes.vue?vue&type=script&lang=ts&"
import style0 from "./VerDetalleSimSolicitudes.vue?vue&type=style&index=0&id=2fd864c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd864c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2fd864c5', component.options)
    } else {
      api.reload('2fd864c5', component.options)
    }
    module.hot.accept("./VerDetalleSimSolicitudes.vue?vue&type=template&id=2fd864c5&scoped=true&", function () {
      api.rerender('2fd864c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SIMSolicitudes/VerDetalleSimSolicitudes.vue"
export default component.exports